import { useEffect } from "react";
import type { Dons } from "../../types/Dons";

function Merci({don}:{don:Dons}){

    useEffect(() => {
        const timeoutId=setTimeout(()=>{
            if(don.checkout_url){
                window.location.href = don.checkout_url;
            }
        },1000);
        return () => { clearTimeout(timeoutId) };
    },[don.checkout_url]);

    return (
        <div>Merci</div>
    )
}
export default Merci;